// Preload swatch images and carousel images when card becomes visible
var observer = new IntersectionObserver(function(entries) {
  entries.forEach(function(entry) {
    if (!entry.isIntersecting) return;
    var card = entry.target;
    card.querySelectorAll('.pc-swatch-dot[data-image]').forEach(function(swatch) {
      var img = new Image();
      img.src = swatch.dataset.image;
    });
    var slides = card.querySelectorAll('.pc-carousel__slide');
    [1, 2].forEach(function(i) {
      if (slides[i]) {
        var slideImg = slides[i].querySelector('img');
        if (slideImg) {
          var img = new Image();
          img.src = slideImg.currentSrc || slideImg.src;
        }
      }
    });
    observer.unobserve(card);
  });
});

document.querySelectorAll('.product-card').forEach(function(card) {
  observer.observe(card);
});

new MutationObserver(function(mutations) {
  mutations.forEach(function(m) {
    m.addedNodes.forEach(function(node) {
      if (node.nodeType !== 1) return;
      if (node.classList && node.classList.contains('product-card')) observer.observe(node);
      node.querySelectorAll && node.querySelectorAll('.product-card').forEach(function(card) {
        observer.observe(card);
      });
    });
  });
}).observe(document.body, { childList: true, subtree: true });

// Swap image and title on swatch hover (desktop)
document.addEventListener('mouseenter', function(e) {
  var swatch = e.target.closest && e.target.closest('.pc-swatch-dot');
  if (!swatch || !swatch.dataset.image) return;

  var card = swatch.closest('.product-card');
  if (!card) return;

  var figure = card.querySelector('.product-card__figure');
  if (!figure) return;

  var overlay = figure.querySelector('.pc-swatch-overlay');
  if (!overlay) {
    overlay = document.createElement('img');
    overlay.className = 'pc-swatch-overlay';
    overlay.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;z-index:2;pointer-events:none;';
    figure.appendChild(overlay);
  }
  overlay.src = swatch.dataset.image;
  overlay.style.display = 'block';

  if (swatch.dataset.title) {
    var titleEl = card.querySelector('.product-title');
    if (titleEl) {
      if (!card.dataset.originalTitle) card.dataset.originalTitle = titleEl.textContent;
      titleEl.textContent = swatch.dataset.title;
    }
  }
}, true);

// Restore image and title on mouseleave (desktop)
document.addEventListener('mouseleave', function(e) {
  var swatchContainer = e.target.closest && e.target.closest('.pc-color-swatches');
  if (swatchContainer) {
    var related = e.relatedTarget;
    if (related && swatchContainer.contains(related)) return;
    var card = swatchContainer.closest('.product-card');
    if (!card) return;
    var overlay = card.querySelector('.pc-swatch-overlay');
    if (overlay) overlay.style.display = 'none';
    var titleEl = card.querySelector('.product-title');
    if (titleEl && card.dataset.originalTitle) {
      titleEl.textContent = card.dataset.originalTitle;
      delete card.dataset.originalTitle;
    }
    return;
  }

  var card = e.target.closest && e.target.closest('.product-card');
  if (!card) return;
  var related = e.relatedTarget;
  if (related && card.contains(related)) return;
  var overlay = card.querySelector('.pc-swatch-overlay');
  if (overlay) overlay.style.display = 'none';
  var titleEl = card.querySelector('.product-title');
  if (titleEl && card.dataset.originalTitle) {
    titleEl.textContent = card.dataset.originalTitle;
    delete card.dataset.originalTitle;
  }
}, true);

// Mobile: show swatches when carousel slide completes
document.addEventListener('carousel:slide-complete', function(e) {
  if (window.innerWidth >= 750) return;

  var carousel = e.target;
  var card = carousel.closest('.product-card');
  if (!card) return;

  // Hide swatches on all other cards
  document.querySelectorAll('.product-card').forEach(function(c) {
    if (c === card) return;
    var s = c.querySelector('.pc-color-swatches');
    if (s) s.style.visibility = 'hidden';
  });

  // Show swatches on this card
  var swatches = card.querySelector('.pc-color-swatches');
  if (swatches) swatches.style.visibility = 'visible';
});